import "https://cdn.jsdelivr.net/npm/element-internals-polyfill@3.0.1/+esm";
import {
  LitElement,
  html,
  css,
  nothing,
} from "https://cdn.jsdelivr.net/gh/lit/dist@2/all/lit-all.min.js";

class MPPrepaidPlan extends LitElement {
  static formAssociated = true;
  static properties = {
    selectedPlan: {},
    popup: { type: Boolean },
  };

  constructor() {
    super();
    this.popup = false;
    this.internals = this.attachInternals();
    this.selectedPlan = "monthly"; // Default selected plan
    this.name = 'selector'; // Name for the component itself in the form
  }

  connectedCallback() {
    super.connectedCallback();
    const form = this.closest('form');

    const monthlyBasePriceCents = 1497; // Example: $14.97 in cents

    this.plans = {
      monthly: {
        key_name: "monthly",
        name_display: "Monthly SUBSCRIPTION",
        months: 1,
        price_per_month: monthlyBasePriceCents,
        total_price_period: monthlyBasePriceCents * 1,
        compare_at_price_per_month: monthlyBasePriceCents,
        saved_amount_cents: 0,
        variant_id: 50503522943314, // REPLACE with actual Variant ID
        selling_plan_id: 691303776594,    // REPLACE with actual Selling Plan ID
        shippingFrequency: 1,
        chargeFrequency: 1,
        popular_badge: false,
        best_value_badge: false,
      },
      six_month: {
        key_name: "six_month",
        name_display: "6 MONTH SUBSCRIPTION",
        months: 6,
        total_price_period: 6290,
        price_per_month: 6290 / 6,
        compare_at_price_per_month: monthlyBasePriceCents,
        saved_amount_cents: (monthlyBasePriceCents * 6) - 6290,
        variant_id: 50736881566034, // REPLACE
        selling_plan_id: 691360760146,    // REPLACE
        shippingFrequency: 1,
        chargeFrequency: 6,
        popular_badge: true,
        best_value_badge: false,
      },
      twelve_month: {
        key_name: "twelve_month",
        name_display: "12 MONTH SUBSCRIPTION",
        months: 12,
        total_price_period: 10784,
        price_per_month: 10784 / 12,
        compare_at_price_per_month: monthlyBasePriceCents,
        saved_amount_cents: (monthlyBasePriceCents * 12) - 10784,
        variant_id: 50737138008402, // REPLACE
        selling_plan_id: 691360956754,    // REPLACE
        shippingFrequency: 1,
        chargeFrequency: 12,
        popular_badge: false,
        best_value_badge: true,
      },
    };

    const initialPlan = this.plans[this.selectedPlan];
    if (!initialPlan) {
      console.error(`MPPrepaidPlan: Initial plan "${this.selectedPlan}" not found in plans data.`);
      return;
    }

    this.value = String(initialPlan.variant_id);
    this.setAttribute("value", this.value);

    const setupHiddenInput = (name, initialValue) => {
      let inputElement;
      if (form) {
        inputElement = form.querySelector(`input[type="hidden"][name="${name}"]`);
      }

      if (inputElement) {
        inputElement.value = initialValue;
      } else {
        inputElement = document.createElement("input");
        inputElement.type = "hidden";
        inputElement.name = name;
        inputElement.value = initialValue;
      }
      return inputElement;
    };

    this.variantIdInput = setupHiddenInput("items[0]id", initialPlan.variant_id);
    this.sellingPlanInput = setupHiddenInput("items[0]selling_plan", initialPlan.selling_plan_id);

    const newInputsToAppend = [
      this.variantIdInput,
      this.sellingPlanInput,
    ].filter(el => el && !el.parentElement);

    if (newInputsToAppend.length > 0) {
      this.after(...newInputsToAppend);
    }
  }

  handleChange(e) {
    const target = e.target;
    this.selectedPlan = target.value;
    const selectedPlanData = this.plans[this.selectedPlan];

    if (!selectedPlanData) {
      console.error(`MPPrepaidPlan: Selected plan "${this.selectedPlan}" not found in plans data during handleChange.`);
      return;
    }

    this.value = String(selectedPlanData.variant_id);
    this.setAttribute("value", this.value);

    if (this.variantIdInput) this.variantIdInput.value = selectedPlanData.variant_id;
    if (this.sellingPlanInput) this.sellingPlanInput.value = selectedPlanData.selling_plan_id;

    for (const element of Array.from(document.querySelectorAll('mp-prepaid-popup'))) {
      element.setAttribute('plan', this.selectedPlan);
    }
    this.requestUpdate();
  }

  static get styles() {
    return css`
@import url('https://fonts.googleapis.com/css2?family=Lilita+One&display=swap');
:host * {
    box-sizing: border-box;
}

.plan.six_month, .plan.twelve_month { /* Grouped for consistent margin */
  margin-top: 16px;
}

/* Adjust margin-top for plans that will have a badge to make space */
.plan.six_month, .plan.twelve_month {
  margin-top: 44px; /* Increased from 16px to accommodate badge height + some space */
}
.plan.monthly {
    margin-top: 16px; /* Default margin for plans without a top badge */
}

:host {
    display: flex;
    flex-direction: column;
    font-family: Josefin Sans, sans-serif;
    width: 100%;
    margin-bottom: 12px;
}
@media screen and (min-width: 760px) {
    :host {
        padding: 0;
    }
}
:host .choose-plan-title {
    font-size: 16px;
    color: #000000;
    letter-spacing: 0.03em;
    line-height: 130%;
    font-weight: 400;
    text-align: center;
}

@media all and (min-width: 768px) {
  :host .choose-plan-title {
    font-size: 18px;
  }
}
:host .plans {
    display: flex;
    flex-direction: column;
    gap: 0px; /* This will be handled by margin-top on .plan elements */
}

:host .plan {
    position: relative; /* Crucial for absolute positioning of the badge */
}
:host input[type="radio"] {
    visibility: hidden;
    position: absolute;
}
:host label {
    background: #FFFFFF;
    display: flex;
    padding: 0 12px 0 12px;
    border-radius: 24px;
    align-items: center;
    border: 1px solid #41A190;
    position: relative;
    cursor: pointer;
    max-height: 90px;
}

@media screen and (min-width: 375px) {
  :host label {
      // height: 75px;
  }
}
@media screen and (min-width: 760px) {
    :host label {
        padding: 0 24px 0 24px;
        min-height: 106px;
         max-height: 114px;
    }
    :host label .checkbox {
    margin-right: 16px;
}
}

:host label .checkbox {
    width: 20px;
    height: 20px;
    min-width: 20px;
    min-height: 20px;
    border: 2px solid #41A190;
    border-radius: 50%;
    display: flex;
    margin-right: 8px;
}
:host input[type="radio"]:checked + label .checkbox {
    border-color: #41A190;
}
:host input[type="radio"]:checked + label .dot {
    width: 70%;
    height: 70%;
    margin: auto;
    border-radius: 50%;
    background-color: #41A190;
}

:host .savings{
font-family: Josefin Sans;
font-weight: 600;
font-style: italic;
font-size: 16px;
leading-trim: Cap height;
letter-spacing: 0%;
vertical-align: bottom;
color: #FFDF4C;
display: block;
}


:host label .prepaid {
    text-align: start;
    padding: 24px 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

:host .plans.popup label .prepaid {
  padding-right: 8px;
}
:host label .prepaid-months {
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 19px;
    color: #2E494A;
    font-family: Josefin Sans;
}
@media all and (min-width: 375px) {
  :host label .prepaid-months {
    font-size: 15px;
    line-height: 1;
  }
}

@media all and (max-width: 768px) {
  :host label .prepaid{
    gap: 5px;
  }
}


@media all and (min-width: 1100px) {
  :host label .prepaid-months {
    font-size: 18px;
  }
}

:host .save {
  font-family: Josefin Sans;
  font-size: 12px;
  font-weight: 400;
  line-height: 130%;
  letter-spacing: 0em;
  text-align: start;
  line-height: 1.1;
}
@media all and (max-width: 768px) {
  :host .plans.popup .save {
    font-size: 15px;
  }
}

@media all and (min-width: 768px) {
  :host .save {
    font-size: 18px;
  }
}
:host label .price-badge {
    display: flex;
    flex-direction: column;
    text-align: center;
    padding: 12px 8px 9px 8px;
    position: relative;
    height: 100%;
    justify-content: center;
    width: 100%;
    max-width: 90px;
    align-items: center;
    margin: 0;
    background-color: #41A190;
    border-radius: 8px;
}

@media all and (min-width: 768px) {
  :host label .price-badge {
    
  }
}

:host label .badge {
    position: absolute;
    top: 0px;
    right: 0;
    font-style: normal;
    font-weight: 900;
    font-size: 14px;
    line-height: 13px;
    letter-spacing: 0.02em;
    text-transform: uppercase;
    padding: 3px 16px;
    border-radius: 0px 0px 5px 5px;
    max-width: 80px;
    border-bottom-left-radius: 80px;
    background-color: #E9D3C2;
    color: #41A190;
    border-top-right-radius: 34px;
}
:host label .badge.hidden {
  visibility: hidden;
}

:host .price-container {
    font-weight: 700;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 0px;
}

:host .plans.popup label .price-badge .you-save {
  font-size: 12px;
  color: #FDEFCE;
  white-space: nowrap;
  line-height: 1.2;
}
:host .plans.popup label .price-badge .actual-price {
  font-size: 18px;
  color: white;
  white-space: nowrap;
  font-weight: 600;
  line-height: 1.2;
}
:host .plans.popup label .price-badge .actual-price span{
  font-size: 12px;
}
:host .price-badge .price {
    font-family: 'Lato', sans-serif;
    font-style: normal;
    font-size: 16px;
    line-height: 24px;
    color: #B12535;
}


@media all and (min-width: 400px) {
  :host .price-badge .price {
    font-size: 18px;
  }
}
@media all and (min-width: 1080px) {
  :host .price-badge .price {
    font-size: 20px;
  }
}

:host .prepaid-price {
  color: #B12535;
}
:host .non-prepaid-price {
    display: inline-block;
    padding-left: 4px;
    text-decoration: line-through;
}

/* --- MODIFIED AND ADDED STYLES FOR TOP BADGE --- */
:host .top-badge {
    display: flex
;
    align-items: start;
    justify-content: center;
    height: 68px;
    position: absolute;
    width: 100%;
    top: -26px;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 20px;
    padding: 8px 12px;
    font-weight: 600;
    font-size: 14px;
    line-height: 1;
    white-space: nowrap;
    z-index: 0;
    text-transform: uppercase;
    letter-spacing: 0.05em;
}

.top-badge.popular {
  color: #ffffff; /* Dark brown text - adjusted from image */
  background-color: #E65F05; /* Orange badge background - from image */
}
.top-badge.best_value {
  color: #FFFFFF; /* White text - from image */
  background-color: #169D61; /* Green badge background - from image */
}
/* --- END OF MODIFIED AND ADDED STYLES FOR TOP BADGE --- */

.non-breaking {
  white-space: nowrap;
}
.free-shipping {
  font-family: Josefin Sans;
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: -1px;
  color: #2E494A;
  text-align: center;
}

.monthly .price-badge{
  background-color: #EDF2F2 !important;
  min-height: 60px;
}

.monthly .price-badge span{
  color: #2E494A !important;
  font-size: 16px !important;
}

:host .total, :host .frequency {
  display: none;
}
    `;
  }

  render() {
    return html`
      <div class="free-shipping">Select your plan</div>
      <div class="plans ${this.popup ? "popup" : ''}">
        ${Object.entries(this.plans).map(
      ([planKey, plan], i) => html`
            <div class="plan ${plan.key_name}">
              ${plan.popular_badge || plan.best_value_badge ?
          html`<div class="top-badge ${plan.popular_badge ? 'popular' : ''} ${plan.best_value_badge ? 'best_value' : ''}">
                    ${plan.popular_badge ? '🔥 MOST POPULAR ✦ 30% OFF ✦' : ''}
                    ${plan.best_value_badge ? '😍 BEST VALUE ✦ 40% OFF ✦' : ''}
                  </div>` : ''}
              <input
                @click="${this.handleChange}"
                id="prepaid-radio-${i}"
                type="radio"
                .checked="${this.selectedPlan === plan.key_name}"
                value="${plan.key_name}"
                name="${this.name}"
              />
              <label class="${plan.key_name}" for="prepaid-radio-${i}">
                <div class="checkbox">
                  <div class="dot"></div>
                </div>
                <div class="prepaid">
                  <div class="prepaid-months">
                    ${plan.name_display.toUpperCase()}
                  </div>
                  <div class="save">
                    ${plan.price_per_month === plan.compare_at_price_per_month ?
          html`Billed Every Month` :
          html`
                        <span class="prepaid-price">Only $${(plan.total_price_period / 100).toFixed(2)}</span>
                        
                        <br>
                        <span>Billed </span>
                        <span class="non-breaking">Every ${plan.months} Months</span>
                      `
        }
                  </div>
                </div>
                <div class="price-badge">
                  ${plan.months > 1 ?
          html`<div class="badge ${this.popup ? 'hidden' : ''}">
                      -${(Math.round((1 - (plan.price_per_month / plan.compare_at_price_per_month)) * 100))}%
                    </div>` : ""}

                  <div class="price-container">
                    ${this.popup && plan.saved_amount_cents && plan.saved_amount_cents > 0 ?
          html`<div>
                            
<div class="actual-price">$${Math.round(plan.price_per_month / 10) / 10}/mo</div>
                          </div>` :
          html`<span class="actual-price">
                            $${(plan.price_per_month / 100).toFixed(2)}/mo
                          </span>`
        }
                      
              ${plan.compare_at_price_per_month > plan.price_per_month
          ? html`
                    <span class="savings"
                      >SAVE $${(
              ((plan.compare_at_price_per_month - plan.price_per_month) *
                plan.months) /
              100
            ).toFixed(0)}</span
                    >
                  `
          : ''}
                  </div>
                </div>
              </label>
            </div>
          `
    )}
      </div>
    `;
  }
}
window.customElements.define("input-mp-prepaid-plan-radios", MPPrepaidPlan);